import { COMPTE_SANS_EMAIL, PARAMETRES, RETOUR } from '../partage/vocabulaire';

/**
 * Les Paramètres du téléphone (ticket 01 du chantier `telephone`) : un panneau dans le cadre,
 * pas une route. L'initiale en haut de chaque écran ouvre « Paramètres » (chantier
 * telephone-habit, 02), qui ouvre « Aide », « Claude branché » ou « Notifications » (chantier
 * notifications-socle, ticket 03) ; chaque retour remonte d'un cran, et toucher un onglet du bas
 * referme tout.
 */
export type PanneauDuPouce = 'parametres' | 'aide' | 'claude' | 'notifications' | null;

/** Où mène le retour d'un panneau : de l'Aide, de Claude branché et des Notifications aux Paramètres, des Paramètres à l'écran. */
export function retourDuPanneau(panneau: PanneauDuPouce): PanneauDuPouce {
  return panneau === 'aide' || panneau === 'claude' || panneau === 'notifications' ? 'parametres' : null;
}

/** Le mot du retour : ce vers quoi il ramène, ou « Retour » quand c'est l'écran d'où l'on vient. */
export function motDuRetour(panneau: PanneauDuPouce): string {
  return retourDuPanneau(panneau) === 'parametres' ? PARAMETRES : RETOUR;
}

/** Ce que dit la ligne « Mon compte » : l'e-mail du compte, ou qu'il n'en a pas. */
export function motDuCompte(email: string | null | undefined): string {
  const propre = email?.trim();
  return propre ? propre : COMPTE_SANS_EMAIL;
}
